
import { ref } from 'vue';
import { defineStore } from 'pinia';
import ApiService from '@/common/api.service';
import { useOrganizationStore } from './organization';

export const useSessionsStore = defineStore('sessions', () => {
  // State
  const sessions = ref([]);
  const currentSession = ref(null);
  const lastSession = ref(null);

  // Actions
  function setCurrentSession(session) {
    currentSession.value = session;
  }

  function setSessions(payload = {}) {
    const data = payload.data || payload;
    const {
      training_sessions: sessionData = [],
      last_training_sessions_id: lastTrainingSessionId,
    } = data || {};
    const sessionList = Array.isArray(sessionData) ? sessionData : [];

    sessions.value = sessionList;
    if (lastTrainingSessionId && lastTrainingSessionId !== -1) {
      const filteredSessions = sessionList.filter((s) => Number(s.id) === Number(lastTrainingSessionId));
      if (filteredSessions.length > 0) {
        [lastSession.value] = filteredSessions;
      } else {
        lastSession.value = null;
      }
    } else {
      lastSession.value = null;
    }
  }

  async function selectSession(sessionId) {
    const normalizedSessionId = Number(sessionId);
    setCurrentSession(null);
    if (!normalizedSessionId) {
      return;
    }
    const session = sessions.value.find((s) => Number(s.id) === normalizedSessionId);
    if (session) {
      setCurrentSession(session);
    } else {
      throw new Error('Session not found');
    }
  }

  function setSession(session) {
    setCurrentSession(session);
  }

  async function fetchSessions(params = {}) {
    const organizationStore = useOrganizationStore();
    const { organizationId } = organizationStore;
    const { data } = await ApiService.query(`front/v1/training_sessions?organization_id=${organizationId}`, params);
    setSessions(data);
    return data;
  }

  async function inviteToSession(code) {
    const { data } = await ApiService.query(`front/v1/invite_to_session?code=${code}`);
    return data;
  }

  function setCurrentSessionProgress(progress) {
    if (currentSession.value) {
      currentSession.value.progress = progress;
    }
  }

  function setCurrentSessionActivatedBadges(activatedBadges) {
    if (currentSession.value) {
      currentSession.value.activated_badge = activatedBadges;
    }
  }
  
  function setLastSession(id){
    lastSession.value = id;
  }

  return {
    sessions,
    currentSession,
    lastSession,
    setCurrentSession,
    setSession,
    setSessions,
    selectSession,
    fetchSessions,
    inviteToSession,
    setCurrentSessionProgress,
    setCurrentSessionActivatedBadges,
    setLastSession,
  };
});
